// 診断

let currentQuestion = 1;

// 診断開始ボタンのクリック処理
$("#diagnosis-start").on("click", function(){
  // スクロール位置
  const headerHeight = $(".site-header-03 .inner").height();
  const scrollElm = (function () {
    if (document.scrollingElement) return document.scrollingElement;
    if (navigator.userAgent.indexOf('WebKit') != -1) return 'body';
    return document.documentElement;
  })();

  let scrollTarget = $(window).width() <= 640 ? $('#diagnosisBalloon') : $('#diagnosisHeading');
  $(scrollElm).animate({
    scrollTop: scrollTarget.offset().top - headerHeight - 20
  }, 800, "swing");

  // 最初の問題を表示
  $(this).closest(".diagnosis-button-wrapper").fadeOut(400, function(){
    $(".diagnosis-box").fadeIn(400);
    $(".js-focus-target").attr("tabindex", "0").focus().attr("tabindex", "-1");
    showQuestion(currentQuestion);
  });
});

// YESとNOのクリック処理
$("#yes").on("click", function(){
  handleAnswer("yes");
});
$("#no").on("click", function(){
  handleAnswer("no");
});

// リトライボタンのクリック処理
$(".js-retry").on("click", function(){
    retryDiagnosis();
  });

//設問を表示する関数
function showQuestion(num) {
  $(".question[data-question='" + num +"']").fadeIn(400);
  $(".diagnosis-box__buttons").css("display", ("flex")).hide().fadeIn(400);
}

// 設問を切り替える関数
function handleAnswer(answer) {
  let $currentQ = $(".question[data-question='" + currentQuestion +"']");
  let $buttons = $(".diagnosis-box__buttons");

  if(currentQuestion === 1) {
    if(answer === "yes") {
        $currentQ.add($buttons).fadeOut(function(){
        currentQuestion = 2;
        showQuestion(currentQuestion);
      });
    } else {
      showResult("fanless");
    }
  } else if(currentQuestion === 2) {
    if(answer === "yes") {
        $currentQ.add($buttons).fadeOut(function(){
        currentQuestion = 3;
        showQuestion(currentQuestion);
      });
    } else {
      showResult("entry");
    }
  } else if(currentQuestion === 3) {
    if(answer === "yes") {
      showResult("space");
    } else {
        $currentQ.add($buttons).fadeOut(function(){
        currentQuestion = 4;
        showQuestion(currentQuestion);
      });
    }
  } else if(currentQuestion === 4) {
    if(answer === "yes") {
      showResult("2u");
    } else {
      showResult("desktop");
    }
  }
}

// 結果を表示する関数
function showResult(id) {
  $(".question").fadeOut(400);
  $(".diagnosis-box__buttons").fadeOut(400, function(){
    $("#result-" + id).fadeIn(400).css("display","flex");
  });
}

// リトライする関数
function retryDiagnosis() {
  $(".diagnosis-box").fadeOut(400, function(){
    $(".result").fadeOut(400);
    $(".diagnosis-button-wrapper").fadeIn(400);
  });
  currentQuestion = 1;
}


// history ボタンclone
$('.history__item--has-button').each(function () {
  const $item = $(this);
  const $originalButton = $item.find('.button-wrapper').first();

  // 元のボタンはPCでのみ表示
  $originalButton.addClass('_sp-display_none');

  // クローンしたボタンはSPでのみ表示
  const $clonedButton = $originalButton.clone().removeClass('_sp-display_none').addClass('_pc-display_none');

  // .history__content の一番下にクローンを追加
  $item.append($clonedButton);
});
